module.exports = __webpack_public_path__ + "img/lacat-gri-1.3ffb63fc.svg";